/* eslint-disable */


import {
    FETCH_ARTICLE_FAILED,
    FETCH_ARTICLE_REQUEST,
    FETCH_ARTICLE_SUCCESS, SET_ERRORS
} from "../mutationTypes";
import ArticleApi from "@shared/_api/article";

const state = {
    article: null,
    loading: false,
};

const actions = {
    fetchArticleById({commit, rootState}, {id, categoryId}) {
        commit(FETCH_ARTICLE_REQUEST);

        let apiFunction = rootState.account.user ? ArticleApi.customerArticlebyId : ArticleApi.byId;

        return apiFunction(id, categoryId).then(article => {
            commit(FETCH_ARTICLE_SUCCESS, article);
        }).catch(error => {
            let errorObj = error;

            if(errorObj.status === 403) {
                errorObj.message = "Access is denied. You may not have the appropriate permissions to access the requested product data."
            }

            commit(FETCH_ARTICLE_FAILED);
            commit(`error/${SET_ERRORS}`, [errorObj], {root: true});
        })
    }
};

const mutations = {
    [FETCH_ARTICLE_SUCCESS](state, article) {
        state.article = article;
        state.loading = false;
    },
    [FETCH_ARTICLE_REQUEST](state, article) {
        state.loading = true;
    },
    [FETCH_ARTICLE_FAILED](state) {
        state.loading = false;
    }

};

export const article = {
    namespaced: true,
    state,
    actions,
    mutations
};